import React from 'react';

// One consistent color mapping for every status word used across the app.
const STATUS_STYLES = {
  paid: { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  'paid up': { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  approved: { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  occupied: { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  active: { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  resolved: { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  sent: { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  success: { bg: 'var(--color-primary-light)', fg: 'var(--color-primary)' },
  pending: { bg: 'var(--color-warning-light)', fg: 'var(--color-warning)' },
  partial: { bg: 'var(--color-warning-light)', fg: 'var(--color-warning)' },
  'due soon': { bg: 'var(--color-warning-light)', fg: 'var(--color-warning)' },
  unmatched: { bg: 'var(--color-warning-light)', fg: 'var(--color-warning)' },
  overdue: { bg: 'var(--color-danger-light)', fg: 'var(--color-danger)' },
  rejected: { bg: 'var(--color-danger-light)', fg: 'var(--color-danger)' },
  unpaid: { bg: 'var(--color-danger-light)', fg: 'var(--color-danger)' },
  failed: { bg: 'var(--color-danger-light)', fg: 'var(--color-danger)' },
  vacated: { bg: 'var(--color-bg-alt)', fg: 'var(--color-muted)' },
  vacant: { bg: 'var(--color-bg-alt)', fg: 'var(--color-muted)' },
  available: { bg: 'var(--color-bg-alt)', fg: 'var(--color-muted)' },
};

function StatusBadge({ status }) {
  const key = (status || '').toLowerCase();
  const { bg, fg } = STATUS_STYLES[key] || { bg: 'var(--color-bg-alt)', fg: 'var(--color-ink-soft)' };
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '3px 10px',
        borderRadius: '999px',
        fontSize: '11px',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        backgroundColor: bg,
        color: fg,
        whiteSpace: 'nowrap',
      }}
    >
      {status}
    </span>
  );
}

export default StatusBadge;
